import React from 'react';
import ReactDOM from 'react-dom/client'; // Updated import from 'react-dom'
import './index.css';
import App from './App';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement // Getting the root element
);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
